import React, { useId } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FiCheck, FiClock, FiAlertTriangle, FiX, FiMinus, FiLoader, FiMail } from 'react-icons/fi';

export const TONE_ICONS = {
    success: FiCheck,
    'success-strong': FiCheck,
    warning: FiClock,
    danger: FiAlertTriangle,
    error: FiX,
    info: FiLoader,
    neutral: FiMinus,
    mail: FiMail,
};

/**
 * Badge sémantique : couleur + icône + libellé (jamais la couleur seule).
 */
const OpsBadge = ({
    tone = 'neutral',
    icon,
    label,
    tooltip,
    tooltipText,
    size = 'md',
    className = '',
}) => {
    const Icon = icon === null ? null : (icon || TONE_ICONS[tone] || FiMinus);
    const tooltipId = useId();
    const accessibleText = tooltipText ?? (typeof tooltip === 'string' ? tooltip : '');

    const badge = (
        <span
            className={`ops-badge ops-badge--${tone} ops-badge--${size} ${className}`.trim()}
            tabIndex={tooltip ? 0 : undefined}
            aria-label={tooltip ? `${label} — ${accessibleText}` : undefined}
        >
            {Icon && <Icon className="ops-badge__icon" aria-hidden="true" />}
            <span className="ops-badge__label">{label}</span>
        </span>
    );

    if (!tooltip) return badge;

    return (
        <OverlayTrigger placement="top" overlay={<Tooltip id={tooltipId}>{tooltip}</Tooltip>}>
            {badge}
        </OverlayTrigger>
    );
};

export default OpsBadge;
